import { Card, CardContent } from "ui/components/card";
import Icon from "components/icon";
import { USER } from "icons";
import classNames from "classnames";

export function EvtClientCard({ user, onClick, selected, disabled }) {
  const fullName = `${user.first_name} ${user.last_name}`;
  return (
    <Card
      className={classNames(" h-max shadow-none py-3", {
        "border-2 border-black": selected?.id === user.id,
      })}
      onClick={disabled ? undefined : onClick}
    >
      <CardContent>
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4 relative">
          <div className="size-10 bg-secondary rounded-full flex place-items-center place-content-center">
            <Icon className="size-4 text-neutral-500" icon={USER} />
          </div>

          <div className="space-y-0.5">
            <h3 className="text-base font-semibold leading-6 text-card-foreground">
              {fullName}
            </h3>
            <p className="text-sm font-normal leading-5 text-muted-foreground">
              {user?.company_id?.name || ""}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
